import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getCookie } from "cookies-next";
import copy from "copy-to-clipboard";
import moment from "moment";
import axios from "../../axios";
import TransactionGenerator from "../TransactionGenerator";
import InvestmentForm from '../invest'
const FirstSection: React.FunctionComponent = () => {
  const [user, setUser] = useState<any>({});
  const [copied, setCopied] = useState(false);

  const userS: any = getCookie("user");
  const LoggedUser = userS ? JSON.parse(userS) : null;
  const [coinsList, setCoinsList] = useState<any>([]);

  useEffect(() => {
    axios
      .get("https://api.coinstats.app/public/v1/coins?skip=0")
      .then((res) => {
        setCoinsList(res.data.coins);
      });
  }, []);
  console.log("/findAllUser/" + LoggedUser._id);
  useEffect(() => {
    axios
      .get("/findUser/" + LoggedUser._id)
      .then((res) => {
        console.log(res.data);
        const user = res.data;

        setUser(user);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [LoggedUser._id]);

  const copyToClipboard = () => {
    

    copy(`http://localhost:3000/?ref=${user.username}`);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  const deposit_date = moment(LoggedUser?.first_deposit_date).add("days", 1);
  const today = moment(new Date()).add("days", 1);
  const interval = today.diff(deposit_date, "days");


  const btc_balance =
    user?.btc_balance
console.log(coinsList)
  const btcPrice = coinsList[15]?.price;
  const currentBTCPrice = Math.round(btc_balance / btcPrice);

  return (
    <section id="dashboard" className="hero-sec">
      <TransactionGenerator />
      <div className="container">
        <div className="row">
          <div className="col-md-12 col-sm-12 mt-5">
            <div className="card">
              <h5 className="card-header text-center p-3">
                Bitcoin TRX Price: ${btcPrice ? btcPrice : 0}
              </h5>
              <div className="align-items-center d-flex justify-content-center">
                <div className="card-body">
                  <h5 className="card-title p-4">
                    Your Balance: $ {btc_balance?.toFixed(6)}<br />
                    <br />
                    Balance in TRX : {currentBTCPrice ? currentBTCPrice : 0}
                  </h5>
                  <Link to="/btc-deposit">
                    <button className="theme-btn wow fadeInUp">Deposit</button>
                  </Link>
                  <Link to="/btc-withdrawal" className="float-right">
                    <button className="theme-btn wow fadeInUp float-right">
                      Withdraw
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3"></div>
          <div className="col-md-6 col-sm-12 mt-5">
            <div className="card">
              <h5 className="card-header text-center p-3">Referral</h5>
              <div className="card-body">
                <div className="align-items-center d-flex justify-content-center">
                  <h5 className="card-title p-4">
                    Total Referral: {user.total_referral} <br />
                    <br />
                    Referral Commission: ${user.referral_commision} 
                    <br />
                    <br />
                    Deposit Commission: ${user.deposit_commision} 
                    <br />
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <InvestmentForm user ={user}/>
        <div className="row ">
          <div className="col-12 text-white text-center mt-5">
            <h1 className="text-white">Referral Link</h1>
            You get 1% on all your downline deposits.
            <br />
            NOTE: Referrals is optional
            <p className=" text-white p-2">
            http://localhost:3000/?ref={user.username}
            </p>
            <p>
              <button
                className="btn btn-md btn-info text-white"
                onClick={copyToClipboard}
              >
                Copy referral link
              </button>
            </p>
            {copied && (
              <div className="form-group row">
                <div className="col-md-12">
                  <p className="text-success" style={{ fontWeight: 500 }}>
                    Referral link copied!
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <br />
      <br />
    </section>
  );
};

export default FirstSection;
